import React from "react";

import { AuthRoute } from "components/AuthRoute";
import { Courses } from "pages/Courses";
import { CourseTest } from "pages/Courses/CourseTest";
import { CreateCourse } from "pages/Courses/CreateCourse";
import { ManageCourse } from "pages/Courses/ManageCourse";
import { ManageLessons } from "pages/Courses/ManageLessons";
import { Home } from "pages/Home";
import { Lessons } from "pages/Lessons";
import { CreateLesson } from "pages/Lessons/CreateLesson";
import { ManageLesson } from "pages/Lessons/ManageLesson";
import { Login } from "pages/Login";
import { NotFound } from "pages/NotFound";
import { Products } from "pages/Products";
import { ManageProduct } from "pages/Products/ManageProduct";
import { Students } from "pages/Students";
import { ViewStudent } from "pages/Students/ViewStudent";
import { TermsAndConditions } from "pages/TermsAndConditions";

// add navLabel for this to appear in <Nav />
export const routes = [
  {
    route: "",
    element: <Home />,
  },
  {
    route: "login",
    element: <Login />,
  },
  {
    route: "/students",
    element: (
      <AuthRoute>
        <Students />
      </AuthRoute>
    ),
    navLabel: "Students",
    children: [
      {
        route: "view/:studentId",
        element: (
          <AuthRoute>
            <ViewStudent />
          </AuthRoute>
        ),
      },
    ],
  },
  {
    route: "/courses",
    element: (
      <AuthRoute>
        <Courses />
      </AuthRoute>
    ),
    navLabel: "Courses",
    children: [
      {
        route: "create",
        element: (
          <AuthRoute>
            <CreateCourse />
          </AuthRoute>
        ),
      },
      {
        route: "manage/:courseId",
        element: (
          <AuthRoute>
            <ManageCourse />
          </AuthRoute>
        ),
      },
      {
        route: "lessons/:courseId",
        element: (
          <AuthRoute>
            <ManageLessons />
          </AuthRoute>
        ),
      },
      {
        route: "test/:courseId",
        element: (
          <AuthRoute>
            <CourseTest />
          </AuthRoute>
        ),
      },
    ],
  },
  {
    route: "/lessons",
    element: (
      <AuthRoute>
        <Lessons />
      </AuthRoute>
    ),
    navLabel: "Lessons",
    children: [
      {
        route: "create",
        element: (
          <AuthRoute>
            <CreateLesson />
          </AuthRoute>
        ),
      },
      {
        route: "manage/:lessonId",
        element: (
          <AuthRoute>
            <ManageLesson />
          </AuthRoute>
        ),
      },
    ],
  },
  {
    route: "/products",
    element: (
      <AuthRoute>
        <Products />
      </AuthRoute>
    ),
    navLabel: "Products",
    children: [
      {
        route: "manage/:productId",
        element: (
          <AuthRoute>
            <ManageProduct />
          </AuthRoute>
        ),
      },
    ],
  },
  {
    route: "/terms-and-conditions",
    element: (
      <AuthRoute>
        <TermsAndConditions />
      </AuthRoute>
    ),
    navLabel: "Terms & Conditions",
  },
  {
    route: "*",
    element: <NotFound />,
  },
];
